// extracted by mini-css-extract-plugin
export default {"form":"FormEdit_form__DxsJ+","content":"FormEdit_content__gRxgn","save":"FormEdit_save__YKb2u"};